import { CheckoutStep } from './btpay-analytics/checkout-step.enum';
import { PaymentStatus } from './payment-status.enum';

const PaymentStatusMap: ReadonlyMap<PaymentStatus, CheckoutStep> = new Map([
  [PaymentStatus.SUCCESS, CheckoutStep.Confirmation],
  [PaymentStatus.PROCESSING, CheckoutStep.Pending],
]);

export { PaymentStatusMap };
